import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularWithdraw: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_withdraw"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="withdraw icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M11.223 9C11.223 8.58579 11.5593 8.25 11.9741 8.25C12.389 8.25 12.7253 8.58579 12.7253 9V13.2981L13.7207 12.3893C14.0269 12.1098 14.502 12.1311 14.7819 12.4368C15.0619 12.7425 15.0406 13.2169 14.7344 13.4964L12.481 15.5535C12.194 15.8155 11.7543 15.8155 11.4673 15.5535L9.21387 13.4964C8.9077 13.2169 8.88643 12.7425 9.16635 12.4368C9.44628 12.1311 9.9214 12.1098 10.2276 12.3893L11.223 13.2981V9Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2591 18.25V5H21.2489C21.6637 5 22 4.66421 22 4.25C22 3.83578 21.6637 3.5 21.2489 3.5L2.75114 3.5C2.3363 3.5 2 3.83579 2 4.25C2 4.66421 2.3363 5 2.75114 5H5.74006V18.25C5.74006 19.4926 6.74895 20.5 7.99348 20.5H16.0057C17.2502 20.5 18.2591 19.4926 18.2591 18.25ZM16.7568 5H7.24234V18.25C7.24234 18.6642 7.57864 19 7.99348 19H16.0057C16.4205 19 16.7568 18.6642 16.7568 18.25V5Z"
        />
      </svg>
    </span>
  );
};

export { RegularWithdraw };
